const util = {
  getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    // let url = window.location.href.split('#')[0]
    let url = window.location.href;
    let search = url.split('?')[1]
    if (search) {
      var r = search.substr(0).match(reg)
      if (r !== null) return unescape(r[2])
      return null
    } else {
      return null
    }
  },
  toBlob(ndata) {
    //ndata为base64格式地址
    let arr = ndata.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    })
  },
  getNonDuplicateID(){
    let str = '';
    str = Math.random().toString(36).substr(3);
    str += Date.now().toString(16).substr(4);
    return str;
  }
}

export default util;



// WEBPACK FOOTER //
// ./src/leo.wang.util/util.js